import { useState, useEffect, useCallback } from 'react';
import styles from './Sidebar.module.css';
import { FiUser } from 'react-icons/fi';
import { BiCube, BiPlusCircle, BiHomeAlt } from 'react-icons/bi';
import { MdOutlineDateRange } from 'react-icons/md';
import { AiOutlineHeart } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotificationBadge from '../../../NotificationBadge/NotificationBadge';

export default function Sidebar() {
  const user = useSelector(state => state?.user?.currentUser);
  const currentUserSaleNotificationCount = useSelector(state => state.user?.currentUserSaleNotificationCount || 0);
  const currentUserOrderNotificationCount = useSelector(state => state.user?.currentUserOrderNotificationCount || 0);
  const notificationCount = currentUserSaleNotificationCount + currentUserOrderNotificationCount;

  const [isOpen, setIsOpen] = useState(false);
  const handleCloseSidebar = useCallback(() => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  }, []);

  const handleToggle = useCallback(e => {
    e?.stopPropagation();
    setIsOpen(prev => !prev);
  }, []);
  useEffect(() => {
    const handleEscape = e => {
      if (e.key === 'Escape') {
        handleCloseSidebar();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [handleCloseSidebar]);

  useEffect(() => {
    const handleClickOutside = () => {
      handleCloseSidebar();
    };

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen, handleCloseSidebar]);

  const menuItems = [
    { label: 'Marktplatz', href: '/', Icon: <BiHomeAlt /> },
    { label: 'Artikel einstellen', href: '/l/new', Icon: <BiPlusCircle /> },
    { label: 'Meine Artikel', href: '/listings', Icon: <BiCube /> },
    { label: 'Meine Buchungen', href: '/inbox/orders', Icon: <MdOutlineDateRange /> },
    { label: 'Favoriten', href: '/favorites', Icon: <AiOutlineHeart /> },
  ];

  return (
    <>
      {/* <button
        className={styles.mobileToggle}
        onClick={handleToggle}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        ☰
      </button> */}

      {/* Overlay for mobile */}
      {isOpen && <div className={styles.overlay} onClick={handleCloseSidebar} />}

      <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`} aria-hidden={!isOpen}>
        <nav className={styles.menu} aria-label="Main navigation">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.href}
              className={styles.menuItem}
              onClick={() => window.innerWidth <= 768 && handleCloseSidebar()}
            >
              <div className={styles.menuItemLeft}>
                {item.Icon}
                <span>{item.label}</span>
              </div>
              {item.href === '/inbox/orders' && notificationCount > 0 && (
                <NotificationBadge className={styles.sidebarBadge} count={notificationCount} />
              )}
            </Link>
          ))}
        </nav>
        {user?.attributes &&
          <div className={styles.userBox}>
            <div className={styles.avatar}>
              <FiUser aria-hidden="true" />
            </div>
            <div className={styles.userDescription}>
              <p className={styles.username}>{`${user?.attributes?.profile?.firstName} ${user?.attributes?.profile?.lastName}`}</p>
              <span className={styles.userEmail}>{user?.attributes?.email}</span>
            </div>
          </div>}
      </aside>
    </>
  );
}

